// constants.js
// ─────────────────────────────────────────────────────────────
// Shared constants used across the app.
// ─────────────────────────────────────────────────────────────

export const SUGGESTION_URL =
  "https://docs.google.com/forms/d/e/1FAIpQLSdBtXTODMNiQdnPWXTB8I5iuLjeHwozUUPaZbfkNifedUi0eA/viewform?usp=publish-editor";
